const colors = {
  primary: "#b23c00",
  secondary: "#8186A0",
  backgroundLight: "#F9F9FC",
};

export default colors;
